import { Component } from "react";

import type { ConnectionWithTotalCount } from "../utils/relay";

import { KibelaSymbol } from "./shared/kibela_symbol";
import type { SizeType } from "./shared/UserAvatar";
import { UserAvatars } from "./shared/UserAvatars";
import type { UserType } from "./shared/UserAvatarWithPopup";

export interface Props {
  users: ConnectionWithTotalCount<UserType>;
  size: SizeType;
  isPopup?: boolean;
  isLink?: boolean;
}

export class UserAvatarsWithOverflowIcon extends Component<Props> {
  static readonly defaultProps = {
    isPopup: true,
    isLink: true,
  };

  render() {
    const { isPopup, isLink, size } = this.props;
    const users = this.props.users.edges.map((edge) => edge.node);

    return (
      <div className="userAvatarsWithOverflowIcon">
        <UserAvatars users={this.props.users} size={size} isPopup={isPopup} isLink={isLink} />

        {this.props.users.totalCount > users.length && (
          <div className={`userAvatarsWithOverflowIcon-overflow is-${this.props.size}`}>
            <KibelaSymbol id="overflow" />
          </div>
        )}
      </div>
    );
  }
}
